import { useMemo } from 'react';

import CookieService from 'App/Services/CookieService';
import SharpstarServiceHandler from 'App/Services/Sharpstar/SharpstarServiceHandler';

/**
 * Memoized `CookieService` for the current hostname and `SharpstarServiceHandler`
 * wired with campaign/source URLs for gambling app flows.
 *
 * @param {object} params
 * @param {string} params.sharpstarApiUrl - Sharpstar API base URL.
 * @param {string} params.source - Traffic source identifier.
 * @param {string|number} params.campaignId - Campaign id passed to Sharpstar.
 * @returns {{ cookiesService: CookieService, sharpstarService: SharpstarServiceHandler }}
 */
export function useGamblingSharpstarService({
    sharpstarApiUrl,
    source,
    campaignId,
}) {
    const cookiesService = useMemo(
        () => new CookieService(window.location.hostname),
        []
    );

    const sharpstarService = useMemo(
        () =>
            new SharpstarServiceHandler(
                sharpstarApiUrl,
                source,
                campaignId,
                cookiesService,
                new AbortController()
            ),
        [sharpstarApiUrl, source, campaignId, cookiesService]
    );

    return { cookiesService, sharpstarService };
}
